var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_796_1584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25086 5C10.3781 5 11.4591 5.44777 12.2561 6.2448C13.0531 7.04183 13.5009 8.12283 13.5009 9.25C13.5036 10.0866 13.2563 10.9049 12.7909 11.6L13.5009 13.5L11.1109 13.07C10.5361 13.3503 9.90547 13.4973 9.26599 13.5C8.62652 13.5027 7.99467 13.361 7.41754 13.0856C6.84041 12.8102 6.33288 12.408 5.93276 11.9092C5.53264 11.4104 5.25025 10.8277 5.10663 10.2045C4.96301 9.58139 4.96184 8.93386 5.10325 8.31021C5.24466 7.68656 5.52499 7.10286 5.92333 6.6026C6.32166 6.10234 6.82776 5.69843 7.4039 5.42095C7.98005 5.14347 8.61138 4.99958 9.25086 5Z",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86002 2.51004C9.18659 1.65311 8.26272 1.02749 7.21703 0.720283C6.17134 0.413077 5.05588 0.439575 4.02596 0.796086C2.99604 1.1526 2.10292 1.82138 1.47093 2.70932C0.838948 3.59725 0.499561 4.66016 0.500023 5.75004C0.496924 6.78604 0.803356 7.79936 1.38002 8.66004L0.500023 11L2.62002 10.62",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_796_1584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon6);
export default __webpack_public_path__ + "static/media/navIcon-6.44b65822b7eb9f35e68db37347a75db8.svg";
export { ForwardRef as ReactComponent };